<!-- Мини-таблица журнала операций (расход/приход) в рамках страницы службы. -->
<template>
  <table class="ops-list">
    <thead>
      <tr>
        <th>{{ $t('household.service.colDate') }}</th>
        <th>{{ $t('household.service.colName') }}</th>
        <th class="num">{{ $t('household.service.colQty') }}</th>
        <th>{{ $t('household.service.colCounterparty') }}</th>
        <th>{{ $t('household.service.colComment') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!rows || !rows.length"><td colspan="5" class="ops-list__empty">{{ $t('common.noData') }}</td></tr>
      <tr v-for="r in rows" :key="r.id">
        <td>{{ fmtDate(r.date) }}</td>
        <td>{{ r.name }}</td>
        <td class="num">{{ r.quantity }} {{ r.unit || '' }}</td>
        <td>{{ r.counterparty || '—' }}</td>
        <td>{{ r.comment || '' }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'OperationsList',
  props: {
    rows: { type: Array, default: () => [] },
    // 'expense' | 'receipt' — сейчас не влияет на разметку, зарезервировано.
    kind: { type: String, default: 'expense' },
  },
  methods: {
    fmtDate(iso) { if (!iso) return ''; const [y, m, d] = String(iso).split('-'); return `${d}.${m}.${y}` },
  },
}
</script>

<style scoped>
.ops-list { width: 100%; border-collapse: collapse; font-size: 13px; }
.ops-list th, .ops-list td { padding: 8px 12px; border-bottom: 1px solid #F3F4F6; text-align: left; }
.ops-list th { background: #F9FAFB; font-weight: 600; color: #374151; }
.ops-list td.num, .ops-list th.num { text-align: right; font-variant-numeric: tabular-nums; }
.ops-list__empty { text-align: center; color: #9CA3AF; padding: 20px; }
</style>
